export const slideStyles = {
  width: "100%",
  height: "100%",
  borderRadius: "10px",
  backgroundSize: "cover",
  backgroundPosition: "center",
  // backgroundColor: "beige",
};

export const rightArrowStyles = {
  position: "absolute",
  top: "50%",
  transform: "translate(0, -50%)",
  right: "32px",
  fontSize: "45px",
  color: "#fff",
  zIndex: 1,
  cursor: "pointer",
};

export const leftArrowStyles = {
  position: "absolute",
  top: "50%",
  transform: "translate(0, -50%)",
  left: "32px",
  fontSize: "45px",
  color: "#fff",
  zIndex: 1,
  cursor: "pointer",
};

export const sliderStyles = {
  position: "relative",
  height: "100%",
};

export const dotsContainerStyles = {
  display: "flex",
  justifyContent: "center",
};

export const dotStyle = {
  margin: "0 3px",
  cursor: "pointer",
  fontSize: "20px",
};

export const containerStyles = {
  width: "120%",
  height: "380px",
  paddingLeft: "5%",
  paddingRight: "5%",
  paddingTop: "10%",
};
